import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ConnectionItem from './ConnectionItem';
import Loading from '../common/Loading.js';

class Connections extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {  
        $('button.tip', $('#tblConnections' + this.props.inbound ? 'Inbound' : 'Outbound')).tooltip();
    }

    render() {
        const artist = this.props.artist;
        const actions = this.props.actions;
        const connections = this.props.connections;
        const inbound = this.props.inbound;
        const inboundOutboundText = inbound ? 'Inbound' : 'Outbound';
        const user = this.props.user;
        const isPluggedIn = this.props.isPluggedIn;
        const getPlugInText = this.props.getPlugInText;
        const getPlugInTooltip = this.props.getPlugInTooltip;
        const connectDisconnect = this.props.connectDisconnect;
        return (
            <div>                
                <table id={`tblConnections${inboundOutboundText}`} className="table table-striped table-userlist table-results">
                    <tbody>
                        {connections && connections.length > 0 ?
                            connections.map((connection, index) => <ConnectionItem key={connection.ID} connection={connection} artist={artist} actions={actions} inbound={inbound} index={index} user={user} isPluggedIn={isPluggedIn} getPlugInText={getPlugInText} getPlugInTooltip={getPlugInTooltip} connectDisconnect={connectDisconnect} />)
                        :
                            <tr>
                                <td colSpan="3">
                                    {(inbound && artist.ConnectionsInboundStatus  == 'LOADING') || (!inbound && artist.ConnectionsOutboundStatus == 'LOADING') ?
                                    <Loading /> : 'No live connections here...'}                                    
                                </td>
                            </tr>                            
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

Connections.propTypes = {
    artist: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    connections: PropTypes.array,
    inbound: PropTypes.bool,
    user: PropTypes.object,
    isPluggedIn: PropTypes.func.isRequired,
    getPlugInText: PropTypes.func.isRequired,
    getPlugInTooltip: PropTypes.func.isRequired,
    connectDisconnect: PropTypes.func.isRequired
};

export default Connections;